import _parseInt from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/core-js/parse-int";
import _objectSpread from "F:\\vft-activities\\d2d\\node_modules\\@babel\\runtime-corejs2/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Record from './Record';
import { mapGetters } from 'vuex';
export default {
  name: 'egg-map',
  components: {
    Record: Record
  },
  computed: _objectSpread({}, mapGetters(['costAllCount', 'giveAllCount', 'eggList'])),
  mounted: function mounted() {
    var _this = this;

    var offsets = [{
      hot: [0, 1],
      left: '3.1rem',
      top: '6.9rem'
    }, {
      hot: [1, 2],
      left: '4.8rem',
      top: '6.8rem'
    }, {
      hot: [2, 5],
      left: '5.3rem',
      top: '8.3rem'
    }, {
      hot: [5, 8],
      left: '6.3rem',
      top: '8.2rem'
    }, {
      hot: [8, 11],
      left: '6.3rem',
      top: '7.2rem'
    }];
    var gifts = this.setting.奖品;
    setInterval(function () {
      if (!_this.$refs.aniContent) {
        return;
      }

      var danLType = _this.eggList[_parseInt(Math.random() * _this.eggList.length)];

      var danRType = _this.eggList[_parseInt(Math.random() * _this.eggList.length)];

      var danL = danLType && danLType.image;
      var danR = danRType && danRType.image;
      _this.$refs.aniContent.innerHTML = '';
      _this.$refs.aniContent.innerHTML = "<div class=\"map_animate ani\">\n        <div class=\"eggs\">\n          <img src=\"".concat(danL, "\" alt=\"\" class=\"left\">\n          <img src=\"").concat(danR, "\" alt=\"\" class=\"right\">\n          <img src=\"").concat(gifts[_parseInt(Math.random() * gifts.length)], "\" alt=\"\" class=\"gift\">\n        </div>\n        <div id=\"mapLottieBox\" class=\"map_lottie\"></div>\n      </div>");
      setTimeout(function () {
        window.bodymovin.loadAnimation({
          path: process.env.NODE_ENV === 'development' ? '/mapLottie/data.json' : '//vm.gtimg.cn/tencentvideo/script/film/v3/d2d/mapLottie/data.json',
          //json文件路径
          loop: false,
          autoplay: true,
          renderer: 'canvas',
          //渲染方式，有"html"、"canvas"和"svg"三种
          container: document.getElementById('mapLottieBox')
        });
      }, 200);

      var el = _this.$refs.aniContent.querySelector('.map_animate');

      var random = _parseInt(Math.random() * 11);

      var offset = offsets.filter(function (item) {
        var result = item.hot[0] <= random && random < item.hot[1];
        return result;
      })[0];
      el.style.left = offset.left;
      el.style.top = offset.top;
    }, 2000);
  },
  settingKey: '碰蛋地图',
  setting: {
    奖品: {
      type: 'array',
      default: ['https://puui.qpic.cn/vupload/0/20181216_1544958539444_nz2eksx3wzj.png/0'],
      items: {
        type: 'string',
        default: ''
      }
    },
    地图背景: '//puui.qpic.cn/vupload/0/20190126_1548751209906_mtgirmoexjh.png/0'
  }
};